import { Flex } from "@fluentui/react-northstar";
import React, { createContext, useContext, useEffect, useState } from "react";
// import OffboardingSearchBar from "./OffboardingSearchBar";
// import { useAgency } from "..";
import OffboardingSearchBar from "./OffboardingSearchBar/OffboardingSearchBar";
import OffboardingMainContent from "./ContentDialogExportUser/OffboardingMainContent";
import { useSearchParams } from "react-router-dom";
import { useQuery } from "react-query";
import { _getAllOffboardingAgencies } from "../api";
import SubHeader from "../../../components/breadcrumb/SubHeader";

const AgencyContext = createContext(); // Déclarez le contexte à l'extérieur de votre composant

export const useAgency = () => useContext(AgencyContext); // Hook pour consommer le contexte

const ListOffboarding = () => {
    const [SelectedUser, setSelectedUser] = useState(null);

    // const { AgencyId } = useAgency();

    const [params, setParams] = useSearchParams();
    const param_tab = params.get("tab");
    const [AgencyId, SetAgencyId] = useState(param_tab ?? null);

    const {
        isLoading,
        data: agencies,
        refetch,
    } = useQuery(
        ["agencys"],
        () => _getAllOffboardingAgencies(),

        {
            onSuccess: (data) => {
                if (!AgencyId && data) {
                    return SetAgencyId(data[0]?.id);
                } else SetAgencyId(Number(param_tab));
            },
            refetchOnWindowFocus: false,
        }
    );

    const menuItems = agencies?.map((agency) => ({
        content: agency.name,
        value: agency.id,
        action_count: agency?.action_count,
    }));

    const onChangeSliderTab = (value) => {
        SetAgencyId(value);
    };

    useEffect(() => {
        if (param_tab) {
            SetAgencyId(Number(param_tab));
        }
    }, []);

    return (
        <AgencyContext.Provider value={{ AgencyId }}>
            <Flex
                column
                styles={{
                    backgroundColor: "#f5f5F5",
                    paddingBottom: "32px",
                }}
            >
                <SubHeader
                    menu={menuItems}
                    setTabView={onChangeSliderTab}
                    defaultSelectedValue={AgencyId}
                    style={{
                        backgroundColor: "white",
                    }}
                />
                <OffboardingSearchBar
                    SelectedUser={SelectedUser}
                    setSelectedUser={setSelectedUser}
                    AgencyId={AgencyId}
                    refetch={refetch}
                />
                <OffboardingMainContent
                    SelectedUser={SelectedUser}
                    setSelectedUser={setSelectedUser}
                    AgencyId={AgencyId}
                />
            </Flex>
        </AgencyContext.Provider>
    );
};

export default ListOffboarding;
